import { BaseDto } from "../base/baseDto.model";

export class UpdateAsuntoRequest  extends BaseDto {
}
